import HelmLocalLocationsSelect from "../form-components/HelmLocalLocationsSelect"
import { Form, FormControl, Button, Row, Col } from "react-bootstrap";
import { ChangeEvent, useState } from "react";
import { usePapaParse } from 'react-papaparse';
import { TranslatorService } from "../../../services/translator-service";
import DownloadLink from "react-download-link";
import * as Papa from 'papaparse';
import { ICoordsWithNameData } from "../../../dto/converters/ICoordsWithNameData";
import {useTranslation} from 'react-i18next';

const HelmLocal = () => {

    const [helmFormInputData, setHelmFormInputData] = useState({ dirLocalToLest: true, location: "1", inputData: [] as ICoordsWithNameData[]});
    const { readString } = usePapaParse();
    const [resultFromApi, setResultFromApi] = useState([] as ICoordsWithNameData[]);
    var fileType = "";
    const [fileLoaded, setFileLoaded] = useState(false);
    const [resultError, setResultError] = useState("");
    const {t} = useTranslation();

    const linkStyle = {
        "display": "block",
        "padding": "0.5rem 1rem",
        "textDecoration": "none",
        "transition": "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out",
        "color": "#707070"
    };

    const queryToApi = async (body: {dirLocalToLest: boolean, location: string, inputData: ICoordsWithNameData[]}) => {
        let result = await TranslatorService.queryApiPost<ICoordsWithNameData[]>(
            "/helm",
            body,
        );
        if (!result.ok) {
            setResultError(t('requestError') + ": " + result.statusCode);
        } else {
            setResultFromApi(result.data!);
        }
    }
    
    function parseCsv(text: string) {
        readString(text, {
            worker: true,
            header: true,
            dynamicTyping: true,
            skipEmptyLines: true,
            complete: (results) => {
                setHelmFormInputData({ ...helmFormInputData, inputData: results.data as ICoordsWithNameData[]});
            },
        });
        setFileLoaded(true);
    }

    function parseTxt(text: string) {
        const resultArray = [] as ICoordsWithNameData[];
        text.split(/[\r\n]+/).forEach((line) => {
            var splitElements = line.trim().split(/\s+/)
            if (splitElements.length === 3 && !isNaN(Number(splitElements[1].replace(/[,]/g, "."))) && !isNaN(Number(splitElements[2].replace(/[,]/g, ".")))) {
                const name = splitElements[0];
                const numberX = Number.parseFloat(splitElements[1].replace(/[,]/g, "."));
                const numberY = Number.parseFloat(splitElements[2].replace(/[,]/g, "."));
                resultArray.push({"nimi": name, "x": numberX, "y": numberY});
            }
            });
        setHelmFormInputData({ ...helmFormInputData, inputData: resultArray});
        setFileLoaded(true);
    }

    const readFile = async (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const file = e.target?.files![0];
        if (file === undefined || file === null) {
            return;
        }
        getFileExtension(file.name);
        setResultFromApi([]);
        const reader = new FileReader();

        reader.onload = async (e) => {
            let text = e.target?.result?.toString();
            if (text !== undefined) {
                if (fileType === "csv") {
                    if (text.includes(';')) {
                        text = text.replaceAll(',', '.').replaceAll(';', ',');
                    }
                    parseCsv(text)
                } else {
                    parseTxt(text);
                }
            }
        }
        reader.readAsText(file);
    }

    function getFileExtension(fileName: string) {
        var splitName = fileName.split('.');
        fileType = splitName[splitName.length - 1].toLowerCase();
        localStorage.setItem("returnType", fileType);
    }


    const generateResult = async () => {
        if(localStorage.getItem("returnType") === "csv") {
            return Papa.unparse(resultFromApi);
        }
        var resultString = "";
        resultFromApi.forEach(object => {
            resultString = resultString + object.nimi + " " +  (object.x ? (helmFormInputData.dirLocalToLest ? object.x.toFixed(3) : object.x) : "-") + " " +  (object.y ? (helmFormInputData.dirLocalToLest ? object.y.toFixed(3) : object.y) : "-") + "\r\n";
        })
        return resultString;
    }

    function isFileLoaded() {
        return fileLoaded;
    }

    return (
        <>
            <Form.Group className="mb-3">
                <Row>
                    <Col>
                        <Form.Check type="radio" name="localMulti" label={t('directionLocalToLEST')} defaultChecked onChange={e => setHelmFormInputData({ ...helmFormInputData, dirLocalToLest: true })} />
                    </Col>
                    <Col>
                        <Form.Check type="radio" name="localMulti" label={t('directionLESTToLocal')} onChange={e => setHelmFormInputData({ ...helmFormInputData, dirLocalToLest: false })} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <HelmLocalLocationsSelect setFormData={setHelmFormInputData} formData={helmFormInputData}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {t('inputFileThreeColumns')}<br />
                        {t('threeColumnCSVFileDescription')}<br />
                        {t('threeColumntextFileDescription')}<br/>
                        {t('dataDescription')}
                        <ul>
                            <li>
                                {t('dataFieldNameText')}
                            </li>
                            <li>
                                {helmFormInputData.dirLocalToLest === true ? t('inputXCoordinate') : <span>x<sub>L-EST97</sub></span>}
                            </li>
                            <li>
                                {helmFormInputData.dirLocalToLest === true ? t('inputYCoordinate') : <span>y<sub>L-EST97</sub></span>}
                            </li>
                        </ul>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormControl id="fileUpload" type="file" accept=".csv,.txt" onChange={readFile}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button 
                        onClick={(e) => {e.preventDefault(); queryToApi(helmFormInputData);}} 
                        disabled={(fileLoaded === false && helmFormInputData.inputData.length === 0)} 
                        type="submit">
                            {t('calculateButtonLabel')}
                        </Button>
                    </Col>
                </Row>
                {(isFileLoaded()) ?
                    <Row>
                        {
                            helmFormInputData.inputData.length !== 0 ?
                            <Col>{t('loadingFileSuccess')}</Col> : <Col>{t('loadingFileFailed')}</Col>
                        }
                    </Row>
                    :
                    ""
                }
                {(resultError.length > 0) ?
                    <Row>
                        <Col>
                            <span className="error-message">{resultError}</span>
                        </Col>
                    </Row>
                    :
                    ""
                }
            </Form.Group>
            {resultFromApi.length > 0 && 
                <DownloadLink style={linkStyle} label={t('downloadResult').toString()} 
                    filename={"helmResult." + localStorage.getItem("returnType")} exportFile={() => Promise.resolve(generateResult())} 
                />
            }
            <br /><br /><br />
        </>
    );

}

export default HelmLocal;

